/** Interna domena. Supabase Auth traži e-poštu; sučelje pita samo korisničko ime. */
export const DOMENA_PRIJAVE = 'prijava.invalid';

export const NAZIVI_ULOGA = {
  superadmin: 'super admin',
  admin: 'admin',
  popisivac: 'popisivač',
  korisnik: 'korisnik',
};

export function nazivUloge(uloga) {
  return NAZIVI_ULOGA[uloga] ?? 'korisnik';
}

/** Admin i super admin smiju mijenjati podatke. Korisnik samo gleda. */
export function jeUpravaUloga(uloga) {
  return uloga === 'admin' || uloga === 'superadmin';
}

export function emailZaKorisnickoIme(ime) {
  const cisto = ime.trim().toLowerCase();
  if (!/^[a-z0-9._-]{2,32}$/.test(cisto)) {
    throw new Error(
      'Korisničko ime smije imati 2–32 znaka: slova, brojke, točku, crticu ili podvlaku.',
    );
  }
  return `${cisto}@${DOMENA_PRIJAVE}`;
}

/** Sredine naselja, općina Gornja Stubica (49245) — samo za orijentaciju na karti. */
export const NASELJA = [
  { naziv: 'Hum Stubički', ll: [45.975862, 16.042319] },
  { naziv: 'Jakšinec', ll: [45.959992, 16.039511] },
  { naziv: 'Karivaroš', ll: [45.959693, 16.055953] },
];

/** Granice unutar kojih točka ima smisla. Izvan toga aplikacija upozorava. */
export const OKVIR = {
  latMin: 45.93,
  latMax: 46.0,
  lngMin: 15.99,
  lngMax: 16.09,
};

export const NAZIVI_VEZE = {
  nositelj: 'nositelj',
  supruga: 'supruga',
  suprug: 'suprug',
  sin: 'sin',
  kci: 'kći',
  stanar: 'stanar',
  ostalo: 'ostalo',
};

export const NAZIVI_STANJA = {
  aktivno: 'aktivno',
  nema_prikljucak: 'nema priključak',
  napusteno: 'napušteno',
  nejasno: 'nejasno — provjeriti',
};

/** 1983. je godina puštanja vodovoda u pogon, ne točna godina priključenja. */
export function opisGodine(g) {
  if (!g) return '—';
  return g <= 1983 ? 'od početka (1983.)' : `${g}.`;
}

export const STATUSI = {
  ne: { naziv: 'Bez pozicije', boja: '#7c8c82' },
  predlozeno: { naziv: 'Za potvrdu', boja: '#6498ac' },
  smjesteno: { naziv: 'Smješteno', boja: '#b69752' },
  potvrdjeno: { naziv: 'Potvrđeno', boja: '#398a66' },
};

export const PODLOGE = [
  {
    kljuc: 'dof',
    naziv: 'Ortofoto',
    opis: 'DGU digitalni ortofoto 2014.–2016.',
    tip: 'wms',
    url: 'https://geoportal.dgu.hr/services/inspire/orthophoto_2014-2016/wms',
    opcije: {
      layers: 'OI.OrthoImagery',
      format: 'image/png',
      maxZoom: 21,
      maxNativeZoom: 19,
      attribution: 'DOF5 &copy; Državna geodetska uprava',
    },
  },
  {
    kljuc: 'osm',
    naziv: 'Karta',
    tip: 'tile',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    opcije: {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    },
  },
  {
    kljuc: 'hok',
    naziv: 'HOK',
    tip: 'wms',
    url: 'https://geoportal.dgu.hr/services/hok/wms',
    opcije: {
      layers: 'hok:HOK5',
      format: 'image/png',
      maxZoom: 20,
      maxNativeZoom: 18,
      attribution: 'HOK &copy; Državna geodetska uprava',
    },
  },
];

/** Prihvaća "45,96 16,03", "45.96, 16.03" i sl.; vraća [lat, lng] ili null. */
export function razdvojiKoordinate(tekst) {
  if (/^-?\d+(?:[.,]\d+)?$/.test(String(tekst).trim())) return null;
  const m = String(tekst)
    .trim()
    .match(/^(-?\d+(?:[.,]\d+)?)\s*(?:;|,|\s)\s*(-?\d+(?:[.,]\d+)?)$/);
  if (!m) return null;
  const lat = Number(m[1].replace(',', '.'));
  const lng = Number(m[2].replace(',', '.'));
  return Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null;
}

export function uOkviru(lat, lng) {
  return (
    lat >= OKVIR.latMin &&
    lat <= OKVIR.latMax &&
    lng >= OKVIR.lngMin &&
    lng <= OKVIR.lngMax
  );
}
